import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import usuario from './modules/usuario';
import empresas from './modules/empresas';
import version from './modules/version';
import mensajeria from './modules/mensajeria'
import app from './modules/app'

export default new Vuex.Store({
	modules: {
    usuario,
    empresas,
		version,
    mensajeria,
    app
  },
});